import { Stack } from "expo-router";
import { FormattedMessage } from "react-intl";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";

export default function NotFoundScreen() {
  return (
    <>
      <Stack.Screen
        options={{
          title: intl.formatMessage({
            id: "uRoKGW",
            defaultMessage: "Oops!",
            description: `This is the title of the screen that is displayed when the user navigates to a screen that doesn't exist.`,
          }),
        }}
      />
      <View flex centerContent paddingMedium colorBackgroundWhite>
        <Text sizeLarge weightExtraBold>
          <FormattedMessage
            id="eR7nsN"
            defaultMessage="Oops! This page does not exist."
            description={`This is a message that is displayed when the user navigates to a screen that doesn't exist.`}
          />
        </Text>
        <Spacer />
      </View>
    </>
  );
}
